import { render, staticRenderFns } from "./rgpd.vue?vue&type=template&id=8d8af596&scoped=true&"
import script from "./rgpd.vue?vue&type=script&lang=js&"
export * from "./rgpd.vue?vue&type=script&lang=js&"
import style0 from "./rgpd.vue?vue&type=style&index=0&id=8d8af596&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d8af596",
  null
  
)

export default component.exports